module.exports = __webpack_public_path__ + "wib_logo-4.png";